import { useDialog } from 'contexts/dialog';
import { useSnackbar } from 'contexts/snackbar';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import courseRequests from 'services/course';

const useDeleteCourse = ({ course, courseId }) => {
    const { setDialog, closeDialog } = useDialog();
    const { message } = useSnackbar();
    const { t } = useTranslation();
    const history = useHistory();

    const deleteCourse = useCallback(async () => {
        await courseRequests.deleteCourse(courseId);
        history.push('/');
        return message.success(
            t('message.delete-course-success', '{{courseName}} was deleted successfully.', {
                courseName: course?.name || 'The new course',
            })
        );
    }, [course?.name, courseId, history, message, t]);

    const openDeleteCourseDialog = useCallback(() => {
        setDialog({
            open: true,
            message: t('dialog.delete-course-success.title', 'Delete {{courseName}}?', {
                courseName: course?.name || 'this course',
            }),
            description: t(
                'dialog.delete-course-success.description',
                'This course will be deleted permanently from our system, and users will lose access immediately. Please note that this action cannot be undone.'
            ),
            variant: 'destructive',
            actionButtonText: t('controls.delete', 'Delete'),
            cancelButtonText: t('controls.cancel', 'Cancel'),
            onAction: () => {
                closeDialog();
                return deleteCourse();
            },
            onCancel: closeDialog,
            onClose: closeDialog,
        });
    }, [closeDialog, course?.name, deleteCourse, setDialog, t]);

    return { openDeleteCourseDialog };
};

export default useDeleteCourse;
